import { Box } from "@mantine/core";
import { TFunction } from "i18next";
import { CreditOptionsResponse, CreditResponse } from "types";
import CreditDetails from "./details";
import CreditPaymentStructure from "./structure";

interface CreditPaymentProps {
  options: CreditOptionsResponse;
  credit: CreditResponse;
  t: TFunction;
}

const CreditPayment = ({ options, credit, t }: CreditPaymentProps) => {

  return (
    <Box p={'lg'}>
      <CreditDetails credit={credit} t={t} />
      <Box mt={64}>
        <CreditPaymentStructure options={options} credit={credit} t={t} />
      </Box>
    </Box>
  )
}

export default CreditPayment;